/**
 * /tenants/$slug/access-governance/policy — routing-policy
 * editor.
 *
 * Shim route. Sibling of /access-governance (the queue) so
 * the access-governance feature has a "queue" tab and a
 * "policy" tab in one nav. Permission gate (access_governance.read
 * for view, access_governance.manage for save) is enforced backend-
 * side; the SPA mounts the page for everyone and the GET/PUT
 * endpoints surface the right errors when the caller lacks
 * permission.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccessGovernancePolicyPage } from "@/features/access-governance-policy/pages/access-governance-policy-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/access-governance/policy",
)({
  component: AccessGovernancePolicyPage,
});
